"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles_1 = require("./styles");
exports.Alert = ({ children, type, className }) => {
    var classes = classnames_1.default("alert", [`alert-${type}`], className);
    if (children) {
        return (react_1.default.createElement(styles_1.Container, { className: classes, dangerouslySetInnerHTML: { __html: children.toString() } }));
    }
    else
        return null;
};
